module.exports = __webpack_public_path__ + "static/media/pic-svg-24.2cd28d66.svg";